export default __webpack_public_path__ + "static/media/downArrow.3bf959ef.svg";